export const TZ = "Asia/Kolkata";

const dayFmt = new Intl.DateTimeFormat("en-CA", { timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit" });

export const todayIST = () => dayFmt.format(new Date());

export function istDateOf(v) {
  if (!v) return "";
  if (/^\d{4}-\d{2}-\d{2}$/.test(String(v))) return String(v);
  const d = new Date(v);
  return isNaN(d) ? String(v).slice(0, 10) : dayFmt.format(d);
}

export function fmtTimeIST(v) {
  if (!v) return "—";
  const d = new Date(v);
  return isNaN(d) ? "—" : d.toLocaleTimeString("en-IN", { timeZone: TZ, hour: "2-digit", minute: "2-digit" });
}

export function addDays(iso, n) {
  const d = new Date(`${iso}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
}

export const weekdayMon0 = (iso) => (new Date(`${iso}T00:00:00Z`).getUTCDay() + 6) % 7;

export function fmtDayLabel(iso) {
  return new Date(`${iso}T00:00:00Z`).toLocaleDateString("en-IN", { timeZone: "UTC", weekday: "short", day: "2-digit", month: "short", year: "numeric" });
}

export function fmtMins(m) {
  if (m == null) return "—";
  const v = Math.round(m);
  if (v < 60) return `${v} min`;
  return `${Math.floor(v / 60)}h ${v % 60}m`;
}

export const PERIODS = [
  { value: "all", label: "All time" },
  { value: "today", label: "Today" },
  { value: "week", label: "This week" },
  { value: "month", label: "This month" },
  { value: "custom", label: "Custom date" },
];

export function filterParams(f) {
  const p = {};
  if (f.period && f.period !== "all") {
    p.period = f.period;
    if (f.period === "custom") {
      const s = f.start || todayIST();
      p.start = s;
      p.end = f.end && f.end >= s ? f.end : s;
    }
  }
  if (f.salesperson && f.salesperson !== "all") p.salesperson = f.salesperson;
  return p;
}
